import { render } from "./ExpiredRecovery.vue?vue&type=template&id=5bcb0fbe&scoped=true"
import script from "./ExpiredRecovery.vue?vue&type=script&lang=js"
export * from "./ExpiredRecovery.vue?vue&type=script&lang=js"

import "./ExpiredRecovery.vue?vue&type=style&index=0&id=5bcb0fbe&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcb0fbe"]])

export default __exports__